import { Chip, Stack, Typography } from "@mui/material";

const FilterChips = ({ options, onChange, title, value }) => {
  const handleClick = (option) => {
    const newValue = value.includes(option)
      ? value.filter((item) => item !== option)
      : [...value, option];

    onChange(newValue);
  };

  return (
    <div>
      <Typography variant="h6" component="h2" gutterBottom>
        {title}
      </Typography>
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        {options.map((option) => (
          <Chip
            key={option}
            label={option}
            clickable
            color={value.includes(option) ? "primary" : "default"}
            onClick={() => handleClick(option)}
          />
        ))}
      </Stack>
    </div>
  );
};

export default FilterChips;
